const ApiTables = {
    'body': '',
    'Timeout': '',
    'start': function () {
        let self = this;
        self.init();

        self.setTables();
        self.setWindowResize();
        self.setCellSameHeight();
    },
    'setTables': function () {
        let self = this;
        let tables = self.body.find('div.table');
        tables.each(function () {
            let table = $(this);
            let rows = table.children().filter('.row');
            rows.each(function () {
                let row = $(this);
                let rowWidth = row.outerWidth();
                let cells = row.children().filter('.cell');
                let cellWidth = rowWidth / (cells.length);
                cells.css('width', cellWidth + 'px');
            });

        });
    },
    'setCellSameHeight': function (row) {
        let self = this;
        setTimeout(function () {
            self.init();
            let tables = self.body.find('div.table');
            tables.each(function(){
                let table = $(this);
                let rows = table.find('.row');
                rows.each(function(){
                    let row = $(this);
                    if (row.hasClass('cell-same-height')) {
                        let panels = row.find('.panel');
                        let cells = row.find('.cell');

                        var maxPanelHeight = 0;
                        cells.each(function () {
                            let cell = $(this);
                            let panel = cell.find('.panel');
                            let panelHeight = panel.outerHeight();
                            if (panelHeight > maxPanelHeight) maxPanelHeight = panelHeight;

                            panels.css('min-height', (maxPanelHeight + 3) + 'px');
                        });
                    }
                });
            });
        }, 200);
    },
    'setWindowResize': function(){
        let self = this;
        $(window).on('resize', function(){
            clearTimeout(self.Timeout);
            self.Timeout = setTimeout(function(){
                ApiTables.start();
            },200);
        });


    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiTables.start();
});
